// recovery-repaginacao-04 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Como se chama esta campanha?": "¿Cómo se llama esta campaña?",
    "Dê um nome à campanha.": "Póngale un nombre a la campaña.",
    "Só para você encontrá-la depois na lista.": "Solo para que usted la encuentre después en la lista.",
};

export default catalogo;
